import React from 'react';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';
import ProjectTitle from '@components/Project/ProjectTitle';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/**
 * InvoiceProjectsList
 *
 * Projects linked to the rows of an invoice or credit note, one per line.
 * Uses the compact ProjectTitle of statements: customer / name, period and product when available.
 */

const ProjectRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.5rem 0;
    border-bottom: ${(props) => props.theme.LighterBorder};

    &:last-child {
        border-bottom: none;
    }

    .project-icon {
        padding-top: 0.1rem;
    }

    .project-title {
        flex: 1 1 0;
        min-width: 0;
    }
`;

const InvoiceProjectsList = ({ projects, onProjectClick }) => {
    return (
        <div>
            {projects.map((project) => (
                <ProjectRow key={project.ID}>
                    <div className="project-icon">
                        <NwIcon icon={byPrefixAndName.fasl['folder']} />
                    </div>
                    <div className="project-title">
                        <ProjectTitle
                            project={project}
                            compact
                            noClientClick
                            linkToProject={() => onProjectClick(project.ID)}
                        />
                    </div>
                </ProjectRow>
            ))}
        </div>
    );
};

export default InvoiceProjectsList;
